var AppointmentPickerDataTestIds = /* @__PURE__ */ ((AppointmentPickerDataTestIds2) => {
  AppointmentPickerDataTestIds2["AvailableSlot"] = "appointments-picker-available-slot";
  AppointmentPickerDataTestIds2["MonthYear"] = "appointments-picker-month-year";
  AppointmentPickerDataTestIds2["NextMonth"] = "appointments-picker-next-month";
  AppointmentPickerDataTestIds2["NextPeriod"] = "appointments-picker-next-period";
  AppointmentPickerDataTestIds2["PrevMonth"] = "appointments-picker-prev-month";
  AppointmentPickerDataTestIds2["PrevPeriod"] = "appointments-picker-prev-period";
  AppointmentPickerDataTestIds2["WorkingDay"] = "appointments-picker-working-day";
  return AppointmentPickerDataTestIds2;
})(AppointmentPickerDataTestIds || {});
export {
  AppointmentPickerDataTestIds
};
